import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatedImage, AnimatedStreemshotCamera } from '@streem/ui-react';
import { useEffect, useMemo, useState } from 'react';
import { Subject, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { useRoomSession } from '../../context/room_session';
import { isHostRoomSession, isOnSiteRoomSession, isSpectatorRoomSession } from '@streem/sdk-core';
export function SuccessfulStreemshot() {
    const animationDuration = 1500;
    const roomSession = useRoomSession();
    const nukeLatestStreemshot = useMemo(() => new Subject(), []);
    const [latestStreemshot, setLatestStreemshot] = useState(undefined);
    useEffect(() => {
        /**
         * Listens for the latest streemshot and sets it in component state
         * It also kicks off a timer to remove the latest streemshot
         */
        let setLatestStreemshotSub;
        if (isHostRoomSession(roomSession)) {
            setLatestStreemshotSub = roomSession.streemshots.latestRequest.subscribe(() => {
                nukeLatestStreemshot.next(undefined);
                setLatestStreemshot({ downloadUrl: '' });
            });
        }
        else {
            setLatestStreemshotSub = roomSession.streemshots.latestResponse.subscribe(streemshot => {
                nukeLatestStreemshot.next(undefined);
                setLatestStreemshot({ downloadUrl: streemshot.downloadUrl ?? '' });
            });
        }
        /**
         * Listens for a signal and starts a timer.
         * When timer completes, sets the latest streemshot to undefined.
         */
        const nukeLatestStreemshotSub = nukeLatestStreemshot
            .pipe(mergeMap(() => timer(animationDuration)))
            .subscribe(() => {
            setLatestStreemshot(undefined);
        });
        return () => [setLatestStreemshotSub, nukeLatestStreemshotSub].forEach(sub => sub.unsubscribe());
    }, [nukeLatestStreemshot, roomSession]);
    if (latestStreemshot &&
        (isSpectatorRoomSession(roomSession) || isOnSiteRoomSession(roomSession))) {
        return (_jsx(AnimatedImage, { animationDuration: animationDuration, src: latestStreemshot.downloadUrl, shouldMask: true }));
    }
    else if (latestStreemshot && isHostRoomSession(roomSession)) {
        return _jsx(AnimatedStreemshotCamera, { animationDuration: animationDuration });
    }
    else {
        return null;
    }
}
//# sourceMappingURL=successful_streemshot.js.map